import React from 'react'
import styled from 'styled-components'

interface Props {
  value: string
  onChange: Function
}

export const SearchBox: React.FC<Props> = ({ onChange, value }) => {
  const [inputValue, setInputValue] = React.useState(value)

  React.useEffect(() => {
    const timer = setTimeout(() => onChange(inputValue.trim().toLowerCase()), 300)
    return () => clearTimeout(timer)
    // onChange 每次 render 都是新參考，列入依賴會重置 debounce 計時器
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValue])

  return (
    <Bar>
      <input type="text" name="keyword" className="form-control" placeholder="Search...." value={inputValue} onChange={e => setInputValue(e.target.value)} />
      <i className="material-icons text-muted">search</i>
    </Bar>
  )
}

const Bar = styled.div`
  position: relative;

  i {
    position: absolute;
    top: 9px;
    right: 8px;
  }
`